export class FilterInfo {
    constructor(options = {}) {
        this.options = {
            queryId: 'beyond-the-daf-listing',
            perPage: 9,
            showingSelector: '.beyond-the-daf__showing',
            totalSelector: '.beyond-the-daf__total',
            hasSearchSummary: false,
            searchOptions: {
                masechetTextSelector: '.beyond-the-daf__masechet-text',
                categoryDescSelector: '.bd-cat-desc .jet-listing-grid__item',
                masechetSelectSelector: '.beyond-the-daf__select .jet-radio-list__input',
                categorySelectSelector: '.beyond-the-daf__categories .jet-radio-list__input',
                titleSelector: '#beyond-the-daf__title',
                categoryTaxName: 'beyond-the-daf-categories'
            },
            modifyInputValue: false,
            inputValuePrefix: 'masechet%{i%'
        };
        
        // Override defaults with provided options
        this.options = { ...this.options, ...options };
        
        this.initEvents();
        if (this.options.modifyInputValue) {
            this.changeSmartFilterValue();
        }
    }

    initEvents() {
        document.addEventListener('jet-smart-filters/inited', this.updateFilters.bind(this));
    }

    updateFilters() {
        const options = this.options;
        
        jQuery(function ($) {
            const pagination = window.JetSmartFilterSettings?.props?.['jet-engine']?.[options.queryId];
            if (pagination) {
                updatePaginationSummary(
                    pagination.page,
                    pagination.max_num_pages,
                    pagination.found_posts
                );
            }
            
            if (options.hasSearchSummary) {
                updateSearchSummary();
            }
            
            window.JetSmartFilters.events.subscribe('ajaxFilters/updated', function (provider, queryId, data) {
                const pagination = data?.pagination;
                if (pagination) {
                    updatePaginationSummary(
                        pagination.page,
                        pagination.max_num_pages,
                        pagination.found_posts
                    );
                }
                
                if (options.hasSearchSummary) {
                    updateSearchSummary();
                }
            });

            function updateSearchSummary() {
                const searchOpts = options.searchOptions;
                let title = '';
                let masechetSearchTitle = $(searchOpts.masechetTextSelector);
                let params = new URLSearchParams(window.location.href);

                if($('.categories-filter .jet-radio-list__input:checked').data('label') == "All" && params.get("tax") && params.get("tax").includes('beyond-the-daf-categories')){
                    params.set("tax",'');
                }

                let taxValue = params.get("tax");

                $(searchOpts.categoryDescSelector).removeClass('visible');

                if (taxValue) {
                    title = '';

                    let pairs = taxValue.split(';');
                    let masechet, categories;

                    pairs.forEach(pair => {
                        let [key, value] = pair.split(':');
                        if (key === 'masechet') {
                            masechet = value;
                        } else if (key === searchOpts.categoryTaxName) {
                            categories = value;
                        }
                    });
                    
                    if (masechet) {
                        const masechetTitle = 
                            $(`${searchOpts.masechetSelectSelector}[value=${masechet}]`)
                            .attr('data-label');
                        if (masechetTitle) {
                            masechetSearchTitle.text(masechetTitle);

                            if (masechetTitle.length > 0) {
                                masechetSearchTitle.removeClass('hidden');
                            } else {
                                masechetSearchTitle.addClass('hidden');
                            }
                        }
                    } else {
                        masechetSearchTitle.addClass('hidden');
                    }

                    if (categories) {
                        const categoryTitle = $(`${searchOpts.categorySelectSelector}[value="${categories}"]`).attr('data-label');
                        if (categoryTitle) {
                            title += ' ' + categoryTitle;
                        }

                        const currentCat = $(`[data-post-id="${categories}"]`);

                        if (currentCat.length) {
                            currentCat.addClass('visible');
                        }
                    }
                } else {
                    masechetSearchTitle.addClass('hidden');
                }

                let isAll = true;
                if(title){
                   isAll = false;
                }

                title = title || AssetsPath.translations.All;

                const $followAll = $('#beyond-follow-all');
                const $followCat = $('#beyond-follow-cat');
                const $followTitle = $('#bd-follow-btn__title');

                $followAll.toggleClass('d-none', !isAll);
                $followCat.toggleClass('d-none', isAll);
                
                if (!isAll && $followTitle.length) {
                    $followTitle.text(title);
                }

                $(searchOpts.titleSelector).text(title);
            }

            function updatePaginationSummary(currentPage, lastPage, total) {
                const perPage = options.perPage;
                const showingPosts = $(options.showingSelector);
                const totalPosts = $(options.totalSelector);
                let showing;
                showing = currentPage * perPage;

                if (currentPage === 1 && total <= perPage) {
                    showing = total;
                }

                if (currentPage === lastPage) {
                    showing = total;
                }

                showingPosts.text(showing);
                totalPosts.text(total);
            }
        });
    }

    changeSmartFilterValue() {
        const queryId = this.options.queryId;
        const prefix = this.options.inputValuePrefix;
        
        let inputs = document.querySelectorAll(`div[data-query-id="${queryId}"] input[name="postmeta.meta_value"]`);

        if (inputs) {
            inputs.forEach(input => {
                if (input.value !== 'all') {
                    input.value = prefix + input.value;
                }
            });
        }
    }
}
